import * as React from 'react';

import RoomTypeDescriptionRepository from '../repositories/RoomTypeDescriptionRepository';
import RoomTypeRepository from '../repositories/RoomTypeRepository';
import RoomRepository from '../repositories/RoomRepository';
import ReviewRepository from '../repositories/ReviewRepository';
import BillRepository from '../repositories/BillRepository';

export default class DependencyInjection extends React.Component<{}, {}> {

    static childContextTypes = {
        room_type_description_repository: React.PropTypes.object,
        room_type_repository:             React.PropTypes.object,
        room_repository:                  React.PropTypes.object,
        review_repository:                React.PropTypes.object,
        bill_repository:                  React.PropTypes.object
    };

    getChildContext() {
        return {
            room_type_description_repository: new RoomTypeDescriptionRepository(),
            room_type_repository:             new RoomTypeRepository(),
            room_repository:                  new RoomRepository(),
            review_repository:                new ReviewRepository(),
            bill_repository:                  new BillRepository()
        };
    }

    render() {
        return (
            <div className="dependency-injection">
              { this.props.children }
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/DependencyInjection.tsx
 **/